module.exports = "images/enfants_7.45e868bc.png";